export default __webpack_public_path__ + "static/media/ConnectionIconOrange.f149b245.svg";